<ng-container *transloco="let t">
    <h2 tuiSheetHeading>
        {{ t('select_the_form_of_ordering') }}
    </h2>

    <section *ngIf="selectedOrderType() === null">
        <ion-list class="menu divide-y" lines="none">
            <ion-item
                class="menu-item"
                *ngIf="allowDelivery()"
                (click)="handleSelect(OrderType.Delivery)"
                [class.menu-item-selected]="cartOrderType() === OrderType.Delivery"
                [button]="true"
            >
                <ion-avatar slot="start">
                    <tui-svg src="icon::delivery-man"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('delivery') }}</p>
                    <p class="text-gray-600">{{ receiver() | formattedAddress }}</p>
                </ion-label>

                <button
                    slot="end"
                    tuiButton
                    appearance="primary"
                    size="s"
                    *ngIf="allowLogin()"
                    (click)="handleChangeReceiver($event)"
                >
                    {{ receiver() ? t('edit_short') : t('choose_an_address') }}
                </button>
            </ion-item>

            <ion-item
                class="menu-item"
                *ngIf="allowPickup()"
                (click)="handleSelect(OrderType.Pickup)"
                [class.menu-item-selected]="cartOrderType() === OrderType.Pickup"
                [button]="true"
            >
                <ion-avatar slot="start">
                    <tui-svg src="icon::shop"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('pickup') }}</p>
                    <p class="text-gray-600">{{ shop()?.address }}</p>
                </ion-label>
                <!--<button slot='end'
                        tuiButton
                        appearance='primary'
                        size='s'
                        (click)='handleChangeShop($event, OrderType.Pickup)'>
                    {{ shop() ? t('edit_short') : t('choose_a_store') }}
                </button>-->
            </ion-item>

            <ion-item
                class="menu-item"
                *ngIf="allowTakeAway()"
                (click)="handleSelect(OrderType.TakeAway)"
                [class.menu-item-selected]="cartOrderType() === OrderType.TakeAway"
                [button]="true"
            >
                <ion-avatar slot="start">
                    <tui-svg src="icon::take-away"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('take_away') }}</p>
                    <p class="text-gray-600">{{ shop()?.address }}</p>
                </ion-label>
                <!--<button
                    slot="end"
                    tuiButton
                    appearance="primary"
                    size="s"
                    (click)="handleChangeShop($event, OrderType.TakeAway)"
                >
                    {{ shop() ? t('edit_short') : t('choose_a_store') }}
                </button>-->
            </ion-item>
            <ion-item
                class="menu-item"
                *ngIf="allowOrderAtTheTable()"
                [button]="true"
                (click)="handleSelect(OrderType.OrderAtTheTable)"
                [class.menu-item-selected]="cartOrderType() === OrderType.OrderAtTheTable"
            >
                <ion-avatar slot="start">
                    <tui-svg src="icon::dinner"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('at_the_table') }}</p>
                    <p class="text-gray-600">
                        {{ t('scan_code_to_order') }}
                    </p>
                </ion-label>
                <button slot="end" tuiButton appearance="primary" size="s" (click)="handleChangeTable($event)">
                    {{ t('scan_code') }}
                </button>
            </ion-item>
        </ion-list>
    </section>

    <section *ngIf="selectedOrderType() === OrderType.OrderAtTheTable">
        <zxing-scanner
            *ngIf="!camerasNotFound() && hasPermission() !== false"
            class="aspect-[3/4] bg-gray-100 shadow"
            [formats]="allowedFormats"
            (camerasNotFound)="camerasNotFoundHandler($event)"
            (scanError)="scanErrorHandler($event)"
            (scanFailure)="scanFailureHandler($event)"
            (scanComplete)="scanCompleteHandler($event)"
            (permissionResponse)="permissionResponseHandler($event)"
        >
        </zxing-scanner>

        <div *ngIf="camerasNotFound()">
            <p class="my-2">{{ t('no_camera_found') }}</p>
        </div>
        <div *ngIf="hasPermission() === false">
            <tui-block-status class="mt-2" [card]="true">
                <img
                    tuiSlot="top"
                    alt="something wrong"
                    ngSrc="/assets/images/304.svg"
                    height="80"
                    width="80"
                    class="w-20 h-20"
                />

                {{ t('no_camera_permission') }}
            </tui-block-status>
        </div>
    </section>

    <!-- <div class="p-4 pt-8">
        <section class="function" *ngIf="selectedOrderType() === null">
            <a class="function-card" (click)="handleSelect(OrderType.TakeAway)">
                <tui-svg src="icon::store" size="l"></tui-svg>

                <h4>{{ t('at_the_counter') }}</h4>
            </a>

            <a class="function-card" (click)="handleSelect(OrderType.OrderAtTheTable)">
                <tui-svg src="icon::dinner" size="l"></tui-svg>
                <h4>{{ t('at_the_table') }}</h4>
            </a>
        </section>

        <section *ngIf="selectedOrderType !== undefined">
            <zxing-scanner
                class="aspect-[3/4] bg-gray-100 shadow"
                [formats]="allowedFormats"
                (camerasNotFound)="camerasNotFoundHandler($event)"
                (scanError)="scanErrorHandler($event)"
                (scanFailure)="scanFailureHandler($event)"
                (scanComplete)="scanCompleteHandler($event)"
            >
            </zxing-scanner>

            <div *ngIf="camerasNotFound">
                <p class="my-2">{{ t('no_camera_found') }}</p>
            </div>
        </section>
    </div> -->
</ng-container>
